export default (allValues: string[], newValue: string) =>
  !allValues.includes(newValue) ? [...allValues, newValue] : allValues
